import type { IEntitlementOverride } from '@experiences/interfaces';

import type {
    IGroupAllocations,
    IUserWithExplicitAllocations,
} from '../../../common/interfaces/licenses';

export enum ServiceLicenseStatus {
    Available = '_0',
    Used = '_1',
    NotAvailable = '_2',
}

export const EntitlementNotNeeded = 'NotNeeded';

export interface IAccountProductDto {
    code: string;
    type: string;
    quantity: number;
    unlimited?: boolean;
}

interface IAccountLicenseDto {
    accountId: string;
    bundleCode: string;
    subscriptionCode: string;
    subscriptionPlan: string;
    licenseCode: string;
    licenseStatus: string;
    products: IAccountProductDto[];
    type: string;
    parentLicenseCode?: string;
}

export interface IProductAvailability {
    code: string;
    type: string;
    unlimited?: boolean;
    availableQuantity: number;
    totalQuantity: number;
    consumedQuantity: number;
}

export interface IOrganizationLicenseWithAvailableProducts {
    license?: IAccountLicenseDto;
    productsWithAvailability: IProductAvailability[];
    entitlementOverrides: IEntitlementOverride[];
}

export interface IProductQuantity {
    code: string;
    quantity: number;
    unlimited?: boolean;
}

export interface IAllocateOrganizationLicenseRequest {
    productQuantities: IProductQuantity[];
    entitlementOverrides: IEntitlementOverride[];
}

export interface IOrganizationLicenseGroup {
    id: string;
    products: IOrganizationLicenseProduct[];
}

export interface IOrganizationLicenseProduct {
    code: string;
    type: string;
    quantity: number;
    available: number;
    consumedQuantity: number;
    unlimited?: boolean;
}

export interface IUserWithExplicitAllocationsPagedResult {
    totalCount: number;
    results: IUserWithExplicitAllocations[];
}

export interface IGroupAllocationsPagedResult {
    totalCount: number;
    results: IGroupAllocations[];
}

export interface IActivationData {
    licenseCode: string;
}

export enum LicenseAllocationMethod {
    EXPLICIT = 'explicitlyAllocated',
    GROUP = 'groupAllocation',
    NONE = 'noLicenses',
}

interface IUserBundleQuota {
    userBundleLicense: string;
    quotaConfig: {
        enabled: boolean;
        value: number;
    };
}

export interface IUserLicenseExplicitAllocation {
    userBundleLicenses: string[];
    useExternalLicense: boolean;
    licenseAllocationMethod: LicenseAllocationMethod;
    userBundleQuotas: IUserBundleQuota[];
}

export interface IConfigureOrganizationLicenses {
    products: { [code: string]: string | number | undefined } | undefined;
    unlimitedProducts?: { [code: string]: boolean | undefined };
    entitlementOverrides: IEntitlementOverride[];
}
